<script setup lang="ts">
const props = defineProps<{
  index?: string
  class?: string
}>()
</script>

<template>
  <div class="mb-2" :class="{ 'flex gap-5': !!index }">
    <div class="flex flex-col items-center" v-if="!!index">
      <div class="h-6 w-6 rounded border-[1px] border-gray-200 pt-[3px] text-center text-xs">{{ index }}</div>
      <div class="mt-1 w-[1px] flex-grow bg-gray-200"></div>
    </div>
    <div :class="class" class="w-full">
      <slot></slot>
    </div>
  </div>
</template>
